import { SHIPMENT_STATS_ACTION_TYPES, SELECT_STAT } from '../actions/shipmentsStats'

const defaultState = {
  isFetching: null,
  params: {},
  error: null,
  counts: {},
  selectedStat: {},
  laneCounts: {},
}

const { STATS_FAILURE, STATS_REQUEST, STATS_SUCCESS } = SHIPMENT_STATS_ACTION_TYPES

const shipmentsStatsReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case STATS_REQUEST: {
      return {
        ...state,
        isFetching: true,
      }
    }
    case STATS_SUCCESS: {
      const {
        payload: {
          quickFiltersCount,
          requestData: { body },
        },
      } = action
      return {
        ...state,
        isFetching: false,
        error: null,
        params: body,
        counts: {
          ...state.counts,
          quickFiltersCount,
        },
      }
    }
    case SELECT_STAT: {
      const { payload } = action
      return { ...state, selectedStat: payload }
    }
    case STATS_FAILURE: {
      const {
        payload: { error },
      } = action
      return {
        ...state,
        isFetching: false,
        error,
      }
    }
    default:
      return state
  }
}

export default shipmentsStatsReducer
